import type { ActionsInboxItem, ActionsInboxOrigin, ActionsInboxUnifiedStatus } from './types';

export const ORIGIN_LABEL: Record<ActionsInboxOrigin, string> = {
  qms_corrective: 'No conformidad (CAPA)',
  risk_action: 'Riesgo / oportunidad',
  objective_task: 'Objetivo de calidad',
  safety_incident: 'Incidente SST',
  emergency_drill: 'Simulacro de emergencia',
  document_ack: 'Acuse de lectura documental',
};

export const STATUS_LABEL: Record<ActionsInboxUnifiedStatus, string> = {
  pending: 'Pendiente',
  in_progress: 'En progreso',
  done: 'Completada',
  cancelled: 'Cancelada',
};

export function buildOriginPath(item: ActionsInboxItem): string {
  switch (item.origin) {
    case 'qms_corrective':
      return `/registros/no-conformidades/${item.refId}`;
    case 'risk_action':
      return `/riesgos/${item.refId}`;
    case 'objective_task':
      return `/objetivos/${item.refId}`;
    case 'safety_incident':
      return '/iso45001/incidentes';
    case 'emergency_drill':
      return '/emergencias?tab=drills';
    case 'document_ack':
      return `/documentos/${item.refId}`;
    default:
      return '/';
  }
}

export function statusBadgeClass(status: ActionsInboxUnifiedStatus): string {
  switch (status) {
    case 'done':
      return 'bg-emerald-100 text-emerald-800';
    case 'in_progress':
      return 'bg-sky-100 text-sky-800';
    case 'cancelled':
      return 'bg-muted text-muted-foreground';
    default:
      return 'bg-amber-100 text-amber-800';
  }
}

export function formatDueDate(iso: string | null): string {
  if (!iso) return '—';
  return new Date(iso).toLocaleDateString('es-AR', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
}
